import { Component, Input } from '@angular/core';
import { ExerciceCategory } from "../../../../common/models/exercice-category";
import { ExerciceCategoryThumbnailComponent } from "../../exercice-category-thumbnail/exercice-category-thumbnail";
import { NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'exercice-category-filters-item',
  templateUrl: './exercice-category-filters-item.html',
  standalone: true,
  imports: [
    ExerciceCategoryThumbnailComponent,
    NgIf,
    TranslateModule
  ],
  styleUrls: ['./exercice-category-filters-item.scss']
})
export class ExerciceCategoryFiltersItemComponent {
  @Input() category!: ExerciceCategory;
  @Input() selected: boolean = false;

}
